import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogAllComment from "./VeltCommentDialogAllComment/VeltCommentDialogAllComment";
import VeltCommentDialogApprove from "./VeltCommentDialogApprove/VeltCommentDialogApprove";
import VeltCommentDialogAssignMenu from "./VeltCommentDialogAssignMenu/VeltCommentDialogAssignMenu";
import VeltCommentDialogAssigneeBanner from "./VeltCommentDialogAssigneeBanner/VeltCommentDialogAssigneeBanner";
import VeltCommentDialogBody from "./VeltCommentDialogBody/VeltCommentDialogBody";
import VeltCommentDialogCommentCategory from "./VeltCommentDialogCommentCategory/VeltCommentDialogCommentCategory";
import VeltCommentDialogCommentIndex from "./VeltCommentDialogCommentIndex/VeltCommentDialogCommentIndex";
import VeltCommentDialogCommentSuggestionStatus from "./VeltCommentDialogCommentSuggestionStatus/VeltCommentDialogCommentSuggestionStatus";
import VeltCommentDialogComposer from "./VeltCommentDialogComposer/VeltCommentDialogComposer";
import VeltCommentDialogCopyLink from "./VeltCommentDialogCopyLink/VeltCommentDialogCopyLink";
import VeltCommentDialogGhostBanner from "./VeltCommentDialogGhostBanner/VeltCommentDialogGhostBanner";
import VeltCommentDialogHeader from "./VeltCommentDialogHeader/VeltCommentDialogHeader";
import VeltCommentDialogMoreReply from "./VeltCommentDialogMoreReply/VeltCommentDialogMoreReply";
import VeltCommentDialogOptions from "./VeltCommentDialogOptions/VeltCommentDialogOptions";
import VeltCommentDialogPriority from "./VeltCommentDialogPriority/VeltCommentDialogPriority";
import VeltCommentDialogPrivateBanner from "./VeltCommentDialogPrivateBanner/VeltCommentDialogPrivateBanner";
import VeltCommentDialogResolveButton from "./VeltCommentDialogResolveButton/VeltCommentDialogResolveButton";
import VeltCommentDialogSignIn from "./VeltCommentDialogSignIn/VeltCommentDialogSignIn";
import VeltCommentDialogStatus from "./VeltCommentDialogStatus/VeltCommentDialogStatus";
import VeltCommentDialogSuggestionAction from "./VeltCommentDialogSuggestionAction/VeltCommentDialogSuggestionAction";
import VeltCommentDialogThreadCard from "./VeltCommentDialogThreadCard/VeltCommentDialogThreadCard";
import VeltCommentDialogThreads from "./VeltCommentDialogThreads/VeltCommentDialogThreads";
import VeltCommentDialogToggleReply from "./VeltCommentDialogToggleReply/VeltCommentDialogToggleReply";
import VeltCommentDialogUpgrade from "./VeltCommentDialogUpgrade/VeltCommentDialogUpgrade";
import VeltCommentDialogCustomAnnotationDropdown from "./VeltCommentDialogCustomAnnotationDropdown/VeltCommentDialogCustomAnnotationDropdown";
import VeltCommentDialogDeleteButton from "./VeltCommentDialogDeleteButton/VeltCommentDialogDeleteButton";
var VeltCommentDialogWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogWireframe.AllComment = VeltCommentDialogAllComment;
VeltCommentDialogWireframe.Approve = VeltCommentDialogApprove;
VeltCommentDialogWireframe.AssigneeBanner = VeltCommentDialogAssigneeBanner;
VeltCommentDialogWireframe.AssignMenu = VeltCommentDialogAssignMenu;
VeltCommentDialogWireframe.Body = VeltCommentDialogBody;
VeltCommentDialogWireframe.CommentCategory = VeltCommentDialogCommentCategory;
VeltCommentDialogWireframe.CommentIndex = VeltCommentDialogCommentIndex;
VeltCommentDialogWireframe.CommentSuggestionStatus = VeltCommentDialogCommentSuggestionStatus;
VeltCommentDialogWireframe.Composer = VeltCommentDialogComposer;
VeltCommentDialogWireframe.CopyLink = VeltCommentDialogCopyLink;
VeltCommentDialogWireframe.GhostBanner = VeltCommentDialogGhostBanner;
VeltCommentDialogWireframe.Header = VeltCommentDialogHeader;
VeltCommentDialogWireframe.MoreReply = VeltCommentDialogMoreReply;
VeltCommentDialogWireframe.Options = VeltCommentDialogOptions;
VeltCommentDialogWireframe.Priority = VeltCommentDialogPriority;
VeltCommentDialogWireframe.PrivateBanner = VeltCommentDialogPrivateBanner;
VeltCommentDialogWireframe.ResolveButton = VeltCommentDialogResolveButton;
VeltCommentDialogWireframe.SignIn = VeltCommentDialogSignIn;
VeltCommentDialogWireframe.Status = VeltCommentDialogStatus;
VeltCommentDialogWireframe.SuggestionAction = VeltCommentDialogSuggestionAction;
VeltCommentDialogWireframe.ThreadCard = VeltCommentDialogThreadCard;
VeltCommentDialogWireframe.Threads = VeltCommentDialogThreads;
VeltCommentDialogWireframe.ToggleReply = VeltCommentDialogToggleReply;
VeltCommentDialogWireframe.Upgrade = VeltCommentDialogUpgrade;
VeltCommentDialogWireframe.CustomAnnotationDropdown = VeltCommentDialogCustomAnnotationDropdown;
VeltCommentDialogWireframe.DeleteButton = VeltCommentDialogDeleteButton;
export default VeltCommentDialogWireframe;
